/**
 * Milliseconds to a compact human-readable duration for admin tables: "42s",
 * "3m 05s" style without zero padding ("3m 5s"), "2h 10m". Null or zero renders as
 * a dash. Extracted from AdminCronJobsPage so the TopDecked ingest section renders
 * durations the same way.
 */
export const formatDuration = (durationMs: number | null | undefined): string => {
  if (!durationMs) return '-';

  const seconds = Math.floor(durationMs / 1000);
  if (seconds < 60) return `${seconds}s`;

  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;
  if (minutes < 60) return `${minutes}m ${remainingSeconds}s`;

  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}h ${remainingMinutes}m`;
};

export default formatDuration;
